;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('FormsController', FormsController)

  /* @ngInject */
  function FormsController () {
  }
})()
